import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { authService } from "../../services/authService";
import "./Home1.scss";
import { checkForArabic } from "../../helpers/arabicLangValidator";
import { Helmet } from "react-helmet";
import { SearchContext } from "../../context/SearchContext";
import SearchBar from "../Search/SearchBar";
import { searchService } from "../../services/searchService";
import settings from "../../settings";
import { flatMap, random, sortBy } from "lodash";
import _ from "lodash";
import swal from "sweetalert";
import { generateSearchLink } from "../../helpers/urls";
import { Suspense } from "react";
import SearchBg from "../../assets/images/search-bg.webp";

const RentalExperience = React.lazy(() =>
  import("../HomeContent/RentalExperience/RentalExperience")
);
const HolidayCarousel = React.lazy(() =>
  import("../HomeContent/HolidayProperties/HolidayCarousel")
);
const Discover = React.lazy(() => import("../HomeContent/Discover/Discover"));
const PopularDestinations = React.lazy(() =>
  import("../HomeContent/Destinations/PopularDestinations")
);
const HostingPlatforms = React.lazy(() =>
  import("../HomeContent/Host/HostingPlatforms")
);
const FAQContent = React.lazy(() => import("../HomeContent/FAQ/FAQContent"));
const CityGuide = React.lazy(() =>
  import("../HomeContent/CityGuide/CityGuide")
);

class Home1 extends Component {
  static contextType = SearchContext;

  constructor(props) {
    super(props);
    this.listingRef = React.createRef();
    this.state = {
      contactVisible: false,
      selectedTag: null,
      paramObj: { title: document?.title, city: "dubai", tags: undefined },
    };
    const params = new URLSearchParams(this.props?.location?.search);
    const admin = params.get("admin");
    if (admin) {
      authService.setAdmin();
    }
  }

  componentDidMount() {
    this.onSearchClick();
  }

  readMoreClick() {
    window.open(`https://www.frankporter.${window.IS_UAE ? "com" : "ru"}`);
  }

  onCityUpdate(tag) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, selectedTag: tag });
  }

  getDetailTitle(obj) {
    const { searchState, setSearchState } = this.context;
    setSearchState({
      ...searchState,
      paramObj: {
        ...this.state.paramObj,
        ...obj,
        city: ["ABU", "abudhabi", "abu-dhabi"].includes(obj?.city)
          ? "abu-dhabi"
          : "dubai",
      },
    });
  }

  onCityClick(city) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, city: city, tags: [], page: 1 }, () => {
      this.onSearchClick();
    });
  }

  onChangeHandler(event) {
    const { searchState, setSearchState } = this.context;
    setSearchState({
      ...searchState,
      [event.target.name]: event.target.value,
    });
  }

  onDatesChange({ startDate, endDate }) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, startDate, endDate, page: 1 }, () => {
      if (
        (startDate !== null && endDate !== null) ||
        (startDate === null && endDate === null)
      ) {
        this.onSearchClick();
      }
    });
  }

  onSortSelect(method) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, sortMethod: method, page: 1 }, () => {
      this.onSearchClick(false);
    });
  }

  onTagsChange(tags) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, tags, page: 1 });
  }

  onChangePage(page) {
    const { searchState, setSearchState } = this.context;
    setSearchState({ ...searchState, page: page }, () => {
      this.onSearchClick(false);
    });
  }

  onGuestChange(guests) {
    const { searchState, setSearchState } = this.context;
    setSearchState({
      ...searchState,
      guests: guests > 0 ? guests : 1,
      page: 1,
    });
  }

  onBedroomsChange(bedrooms) {
    const { searchState, setSearchState } = this.context;
    setSearchState({
      ...searchState,
      bedrooms: bedrooms,
      page: 1,
    });
  }

  prepareUrlForHistory() {
    const { searchState } = this.context;
    return generateSearchLink(
      searchState.city.urlName,
      searchState.startDate,
      searchState.endDate,
      searchState.guests,
      searchState.sortMethod?.translationKey,
      searchState.page,
      searchState.tags,
      searchState.bedrooms,
      searchState.searchText
    );
  }

  handleShuffleIfNeeded(list, isDefault) {
    if (isDefault) {
      return sortBy(list, (item) =>
        item.tags.includes("TOP_STAR") ? 0 : random(1, 100)
      );
    }
    return list;
  }

  onSearchClickEvent(event) {
    if (event) {
      event.preventDefault();
    }
    const { searchState } = this.context;
    const { city, startDate, endDate, guests, tags, bedrooms, searchText } =
      searchState;

    const noFiltersApplied =
      !startDate &&
      !endDate &&
      guests === 1 &&
      tags.length === 0 &&
      bedrooms.length === 0 &&
      !searchText;

    if (
      noFiltersApplied &&
      city.urlName === "dubai" &&
      this.props.location.pathname === "/"
    ) {
      this.props.history.push("/dubai");
      return;
    }
    this.onSearchClick();
  }

  onSearchClick = async (getMapProperties = true) => {
    const { searchState, setSearchState } = this.context;
    this.onCityUpdate(this.state.city);
    const {
      city,
      startDate,
      endDate,
      guests,
      sortMethod,
      page,
      tags,
      searchText,
      bedrooms,
    } = searchState;

    const paramsForDefaultPage = {
      checkIn: startDate ? startDate.format("YYYY-MM-DD") : null,
      checkOut: endDate ? endDate.format("YYYY-MM-DD") : null,
      guests,
      sort: sortMethod ? sortMethod : null,
      page: parseInt(page),
      tags: tags.map((tag) => tag.tag),
      bedrooms: flatMap(bedrooms, (bedroom) => bedroom.values),
      searchText,
    };

    // define getListingParams in the same scope you use it
    let getListingParams = {
      cityTag: city.tag,
      ...paramsForDefaultPage,
    };

    const isDefaultSearch = searchService.isDefaultSearch({
      ...getListingParams,
      sortKey: getListingParams.sort.key,
    });
    
    getListingParams = {
      ...getListingParams,
      is_star: isDefaultSearch && page === 1 ? 1 : 0,
    };

    if (!_.isEqual(this.listingRef.current, getListingParams)) {
      setSearchState((prev) => ({ ...prev, downloadingItems: true }));
      this.listingRef.current = getListingParams;

      this.props.history.push(this.prepareUrlForHistory());

      try {
        // first request – wait for full body
        const searchResult = await searchService.getAvailableListings(
          getListingParams
        );

        if (isDefaultSearch) {
          localStorage.setItem(settings.isDefaulSearch, isDefaultSearch);
        } else {
          localStorage.removeItem(settings.isDefaulSearch);
        }
        if (isDefaultSearch && getListingParams.page === 1) {
          localStorage.setItem(
            settings.defaultStarProperties,
            searchResult.count
          );
        }

        const firstPagePropertiesCount = isDefaultSearch
          ? localStorage.getItem(settings.defaultStarProperties)
          : settings.actualItemsPerPage;

        setSearchState((prev) => ({
          ...prev,
          properties: [
            ...this.handleShuffleIfNeeded(
              searchResult.results,
              isDefaultSearch
            ),
          ],
          ...((!isDefaultSearch ||
            (isDefaultSearch && getListingParams.page > 1)) && {
            totalProperties: isDefaultSearch
              ? Number(searchResult.totalItems) +
                Number(firstPagePropertiesCount)
              : searchResult.totalItems,
          }),
          getListingParams,
        }));

        // second request – also awaited
        if (isDefaultSearch && getListingParams.page === 1) {
          const countRes = await searchService.getAvailableListingsCount(
            getListingParams
          );
          setSearchState((prev) => ({
            ...prev,
            totalProperties:
              Number(countRes.totalItems) +
              Number(localStorage.getItem(settings.defaultStarProperties)),
          }));
        }

        if (getMapProperties) {
          this.getAvailableListingsForMap(getListingParams);
        }
      } catch (err) {
        swal({
          text: this.props.t("common:errorPropertiesData"),
          className: checkForArabic("arabic-modal"),
        });
        setSearchState((prev) => ({ ...prev, downloadingItems: false }));
      } finally {
        // loader hides only after everything above is done
        setSearchState((prev) => ({ ...prev, downloadingItems: false }));
      }
    }
  };

  getAvailableListingsForMap(params) {
    const { searchState, setSearchState } = this.context;
    setSearchState({
      ...searchState,
      downloadingMapItems: true,
    });
    searchService
      .getAvailableListingsForMap(params)
      .then((result) => {
        setSearchState({ ...searchState, mapProperties: result.results });
      })
      .finally(() => {
        setSearchState({
          ...searchState,
          downloadingItems: false,
          downloadingMapItems: false,
        });
      });
  }

  render() {
    const { searchState } = this.context;
    const { t } = this.props;
    return (
      <div
        className={`home1-container ${checkForArabic("arabic-home-container")}`}
      >
        <Helmet>
          <title>Frank Porter Booking Site For Holiday Rentals in UAE</title>
           <meta
          name="description"
          content="Book premium short-term rentals in the UAE with Frank Porter. Enjoy fully furnished apartments, flexible stays, and seamless booking."
        />
          <link rel="canonical" href={`${process.env.REACT_APP_BASE_URL}`} />
          <link rel="preload" as="image" href={SearchBg} />
        </Helmet>
        <div className="content">
          <div className="search-criteria">
            <div className="overlay">
              {/* <div className="image-container">
              <h1>{t("holidayRentalTitle")}</h1>
              <p
                dangerouslySetInnerHTML={{ __html: t("holidayRentalDesc") }}
              ></p>
              </div> */}
            </div>
            <div className="image-container">
              <h1>{t("holidayRentalTitle")}</h1>
              <p
                dangerouslySetInnerHTML={{ __html: t("holidayRentalDesc") }}
              ></p>
            </div>
            <div className="search-bar">
              <SearchBar
                state={searchState}
                cities={searchState.cities?.filter(({ visible }) => visible)}
                tags={searchState.tags}
                bedrooms={searchState.bedrooms}
                onChangeHandler={this.onChangeHandler.bind(this)}
                onCityClick={this.onCityClick.bind(this)}
                onTagsChange={this.onTagsChange.bind(this)}
                onBedroomsChange={this.onBedroomsChange.bind(this)}
                onGuestChange={this.onGuestChange.bind(this)}
                onDatesChange={this.onDatesChange.bind(this)}
                onSearchClick={this.onSearchClickEvent.bind(this)}
              />
            </div>
          </div>
          <Suspense fallback={<div>Loading content...</div>}>
            <div className="property-content">
              <RentalExperience />
              <HolidayCarousel {...this.props} />
              <Discover />
              <PopularDestinations />
              <HostingPlatforms />
              <FAQContent />
              <CityGuide />
            </div>
          </Suspense>
        </div>
      </div>
    );
  }
}

export default withTranslation("home")(Home1);
